export class PoData{
    poQty:number[];

}